<template>
  <div class="form-body">
    <h4 class="form-section">
      <i class="icon-user"></i>{{ $t("labels.general") }}
    </h4>
    <div class="row bottom-space" v-show="$store.state.patients.length > 0 || currentRoute !== 'newPatient'">
      <div class="col-md-6">
        <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="defaultPatient" v-model="patient.default">
            <label class="custom-control-label float-left" for="defaultPatient">{{ $t("labels.default") }}</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="projectinput1"><span class="required">*</span>{{ $t("labels.firstName") }}</label>
          <input type="text" required="required" class="form-control" v-model="patient.name">
        </div>
        <div class="form-group">
          <label for="projectinput2"><span class="required">*</span>{{ $t("labels.lastName") }}</label>
          <input type="text" class="form-control" v-model="patient.surname">
        </div>
        <div class="form-group">
          <label for="birthDate">{{ $t("labels.birthDate") }}</label>
          <date-picker v-model="patient.birthDate" :lang="$i18n.locale" width="100%" type="date" appendToBody format="DD/MM/YYYY"></date-picker>
        </div>
      </div>
      <div class="col-md-3"  v-if="!patient.avatar">
        <div class="dropzone avatar-upload bottom-space" @click="$refs.avatar.click()">
            <h5>
              {{ $t("labels.uploadAvatar") }}
              <span><strong>{{ $t('labels.maxImageSize') }}</strong><br>5 Mb</span> 
              <span><strong>{{ $t('labels.allowedFormats') }}:</strong><br>{{ $store.state.allowedImageTypesSimple.toString().split(',').join(', ') }}</span>
            </h5> <br>
        </div>
      </div>
      <input type="file" id="avatar" ref="avatar" @change="getAvatar" style="display:none">
      <div class="col-md-3 p-0">
          <div class="bottom-space" @click="$refs.avatar.click()" style="cursor:pointer">
            <div class="col-md-12 pt-2">
              <figure v-if="currentAvatar.name">
                <img :src="getUrl(currentAvatar)" alt="index">
                <figcaption>
                  <span><strong>{{ $t('labels.name') }}:</strong> {{ currentAvatar.name }}</span> <br />
                  <span :class="{red: currentAvatar.size/1024/1024 > 5}"><strong>{{ $t('labels.size') }}:</strong> {{ Math.round(currentAvatar.size/1024) }} Kbyte</span> <br />
                  <span :class="{red: !$store.state.allowedImageTypes.includes(currentAvatar.type)}"><strong>{{ $t('labels.type') }}:</strong> {{ currentAvatar.type }}</span>
                </figcaption>
              </figure>
              <figure v-if="patient.avatar && patient.avatar.signed_url && !currentAvatar.name">
                <img :src="patient.avatar.signed_url" alt="index">
              </figure>
            </div>
          </div>
          <div class="col-md-2" v-if="(currentAvatar && currentAvatar.name) || patient.avatar">
            <a class="warning p-0" @click.prevent="deleteAvatar"><i class="fa fa-trash font-medium-3 mr-2"></i></a>
          </div>
      </div>
    </div>
    <size-and-blood-widget :patient="patient" v-if="$route.name != 'newPatient'"></size-and-blood-widget>
    <div class="row">
        <div class="col-md-6">
            <div class="form-group">
                <label for="projectinput2">{{ $t("labels.bloodGroup") }}</label>
                <select id="patientCountry" class="form-control" v-model="patient.bloodGroup">
                  <option value="0 Rh+">0 Rh+</option>
                  <option value="0 Rh">0 Rh</option>
                  <option value="A Rh+">A Rh+</option>
                  <option value="A Rh-">A Rh-</option>
                  <option value="B Rh+">B Rh+</option>
                  <option value="B Rh-">B Rh-</option>
                  <option value="AB Rh+">AB Rh+</option>
                  <option value="AB Rh-">AB Rh-</option>
                </select>
            </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="projectinput4">{{ $t("labels.pathology") }}</label>
            <select class="form-control" v-model="pathologyId" @change="changePathology">
              <option selected value> -- select pathology -- </option>
              <option v-for="tp in pathologies" :value="tp._id" :key="tp._id">{{ tp.name[$i18n.locale] }}</option>
            </select>
          </div>
        </div>
        <!--
        <div class="col-md-4">
            <div class="form-group">
                <label for="projectinput2">{{ $t("labels.heightCm") }}</label>
                <div class="input-group">
                    <input type="number" class="form-control" v-model.number="patient.heightCm">
                    <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon2">cm</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label for="projectinput2">{{ $t("labels.weightKg") }}</label>
                <div class="input-group">
                    <input type="number" class="form-control" v-model.number="patient.weightKg">
                    <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon2">kg</span>
                    </div>
                </div>
            </div>
        </div>
        -->
    </div>
    <h4 class="form-section">
      <i class="icon-user"></i>{{ $t("labels.patientSize") }}
    </h4>
    <div class="row bottom-space" v-if="$route.name != 'newPatient'">
      <div class="col-12 col-sm-6">
        <button href="#" :disabled="sizeForm" @click.prevent="newSize('new')" class="btn btn-info">{{ $t("labels.newSize") }}</button>
      </div>
      <div class="col-12 col-sm-6 text-sm-right" v-if="patient.growthHistory && patient.growthHistory.length > 0">
        <button href="#" :disabled="sizeForm" @click.prevent="newSize('edit')" class="btn btn-info">{{ $t("labels.editSize") }}</button>
      </div>
    </div>
    <div class="size-form-container" v-if="sizeForm || $route.name == 'newPatient'">
      <size-form :patient="sizes" v-if="sizeForm || $route.name == 'newPatient'" v-on:cancelsizechange="cancelSizeChange" v-on:savesizechange="saveSizeChange" :size-intent="sizeIntent"></size-form>
    </div>
    <!--
    <div class="row bottom-space" v-if="patient.growthHistory && patient.growthHistory.length > 0">
        <div class="col-md-12" id="gch2" ref="gch2">
            <h4>{{ $t("labels.heightHistory") }}</h4>
            <GChart
                type="LineChart"
                :data="heightChanges"
                :options="heightChartOptions"
                width="100%"
                ref="heightChart"
            />
            <div id="hcimage" ref="hcimage"></div>
        </div>
    </div>
    <div class="row bottom-space" v-if="patient.growthHistory && patient.growthHistory.length > 0">
        <div class="col-md-12" id="gch2" ref="gch2">
            <h4>{{ $t("labels.weightHistory") }}</h4>
            <GChart
                type="LineChart"
                :data="weightChanges"
                :options="weightChartOptions"
                width="100%"
                ref="weightChart"
            />
            <div id="wcimage" ref="wcimage"></div>
        </div>
    </div>
    <div class="row bottom-space" v-if="patient.growthHistory && patient.growthHistory.length > 0">
        <div class="col-md-12" id="gch2" ref="gch2">
            <h4>{{ $t("labels.growthHistory") }}</h4>
            <GChart
                type="LineChart"
                :data="growthChanges"
                :options="growthChartOptions"
                width="100%"
                ref="growthChart"
            />
            <div id="gcImage" ref="gcImage"></div>
        </div>
    </div>
    -->
    <h4 class="form-section">
      <i class="icon-user"></i>{{ $t("labels.address") }}
    </h4>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="projectinput1">{{ $t("labels.street") }}</label>
          <input type="text" class="form-control" v-model="patient.street">
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="projectinput2">{{ $t("labels.city") }}</label>
          <input type="text" class="form-control" v-model="patient.city">
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label for="projectinput2">{{ $t("labels.zipCode") }}</label>
          <input type="text" class="form-control" v-model="patient.zipCode">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label for="projectinput1">{{ $t("labels.province") }}</label>
          <input type="text" class="form-control" v-model="patient.province">
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="projectinput2">{{ $t("labels.region") }}</label>
          <input type="text" class="form-control" v-model="patient.region">
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="patientCountry">{{ $t("labels.country") }}</label>
          <select id="patientCountry" class="form-control" v-model="patient.country">
            <option value="Italy">Italy</option>
            <option value="Austria">Austria</option>
            <option value="Belgium">Belgium</option>
            <option value="Bulgaria">Bulgaria</option>
            <option value="Croatia">Croatia</option>
            <option value="Cyprus">Cyprus</option>
            <option value="Czechia">Czechia</option>
            <option value="Denmark">Denmark</option>
            <option value="Estonia">Estonia</option>
            <option value="Finland">Finland</option>
            <option value="France">France</option>
            <option value="Germany">Germany</option>
            <option value="Greece">Greece</option>
            <option value="Hungary">Hungary</option>
            <option value="Ireland">Ireland</option>
            <option value="Latvia">Latvia</option>
            <option value="Lithuania">Lithuania</option>
            <option value="Luxembourg">Luxembourg</option>
            <option value="Malta">Malta</option>
            <option value="Netherlands">Netherlands</option>
            <option value="Poland">Poland</option>
            <option value="Portugal">Portugal</option>
            <option value="Romania">Romania</option>
            <option value="Slovakia">Slovakia</option>
            <option value="Slovenia">Slovenia</option>
            <option value="Spain">Spain</option>
            <option value="Sweden">Sweden</option>
            <option value="United Kingdom">United Kingdom</option>
          </select>
        </div>
      </div>
    </div>
    <!--
    <h4 class="form-section">
      <i class="icon-user"></i>{{ $t("labels.other") }}
    </h4>
    <div class="row bottom-space">
      <div class="col-md-6">
        <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="dravetNetParticipant" v-model="patient.dravetNetParticipant">
            <label class="custom-control-label float-left" for="dravetNetParticipant">{{ $t("labels.dravetNetParticipant") }}</label>
        </div>
      </div>
    </div>
    -->
    <h4 class="form-section">
      <i class="icon-user"></i>{{ $t("labels.emergencyCertificate") }}
    </h4>
    <div class="row" id="emergency-certificate">
      <div class="col-md-6">
          <div class="dropzone bottom-space">
              <h5>{{ $t("labels.uploadEmergencyCertificate") }}</h5> <br>
              <input type="file" id="certificate" ref="certificate" @change="getCertificate">
          </div>
          <div class="row" v-if="currentCertificate.name">
              <div class="col-md-10">
                  {{ currentCertificate.name }}
              </div>
              <div class="col-md-2">
                <a class="warning p-0" @click.prevent="deleteCertificate"><i class="fa fa-trash font-medium-3 mr-2"></i></a>
              </div>
          </div>
        <a type="application/pdf" :href="patient.certificate.signed_url " class="btn btn-success" target="_blank" v-if="patient.certificate && patient.certificate.signed_url"><i class="fa fa-download"></i> {{ $t('labels.certificate')}}</a>
      </div>
    </div>
    <h4 class="form-section">
      <i class="icon-user"></i>{{ $t("labels.emergencyNumbers") }}
    </h4>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="emergencyNumberName">{{ $t("labels.name") }}</label>
          <input type="text" id="emergencyNumberName" class="form-control" v-model="emergencyNumber.name">
        </div>
        <div class="form-group">
          <label for="emergencyNumber">{{ $t("labels.emergencyNumber") }}</label>
          <input type="text" id="emergencyNumber" class="form-control" v-model="emergencyNumber.phone">
        </div>
        <label for="emergencyNumberNote">{{ $t("labels.emergencyNumberNote") }}</label>
        <textarea class="form-control bottom-space" id ="emergencyNumberNote" v-model="emergencyNumber.note"></textarea>
        <button type="button" class="btn btn-success" @click.prevent="addNumber">
            <i class="icon-note"></i> {{ this.$t("labels.addNumber") }}
        </button>
      </div>
      <div class="col-md-6" v-if="patient.emergencyNumbers && patient.emergencyNumbers.length > 0">
        <table class="table table-responsive-sm">
          <thead>
            <th>
              {{ $t("labels.name") }}
            </th>
            <th>
              {{ $t("labels.emergencyNumber") }}
            </th>
            <th>
              {{ $t("labels.emergencyNumberNote") }}
            </th>
            <th>
              {{ $t("labels.actions") }}
            </th>
          </thead>
          <tbody>
            <tr v-for="(number, index) in patient.emergencyNumbers" :key="index">
              <td>
                {{ number.name }}
              </td>
              <td>
                {{ number.phone }}
              </td>
              <td>
                {{ number.note }}
              </td>
              <td>
                <a href="#" @click.prevent="deleteNumber(index)">
                  <i class="fa fa-trash font-medium-3 mr-2"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import LovService from '@/services/lov'
import TherapyForm from './TherapyForm.vue'
import TherapyData from './TherapyData.vue'
import SizeForm from './SizeForm.vue'
import patient from '../../services/patient'
import {GoogleCharts} from 'google-charts'
import _ from 'lodash'
import moment from 'moment'
import SizeAndBloodWidget from './SizeAndBloodWidget.vue'

export default {
  props: ["patient"],
  components: {
    TherapyForm,
    TherapyData,
    SizeForm,
    SizeAndBloodWidget
  },
  data() {
    return {
      pathologies: [],
      pathologyId: '',
      errors: [],
      intent: '',
      sizeIntent: '',
      emergencyNumber: {
        name: '',
        phone: ''
      },
      sizes: {
        height: 0,
        weight: 0,
        dateOfChangeForNew: new Date().getTime(),
        dateOfChangeForEdit: null
      },
      numErrors: [],
      currentCertificate: {},
      currentAvatar: {},
      therapyForm: false,
      sizeForm: false,
      currentTherapy: {
        startDate: '',
        endDate: '',
        drugs: []
      },
      heightChartOptions: {
          width: '100%',
          height: 300,
          chart: {
              title: 'Height changes'
          }
      },
      heightChanges: [],
      weightChartOptions: {
          width: '100%',
          height: 300,
          chart: {
              title: 'Weight changes'
          }
      },
      weightChanges: [],
      growthChartOptions: {
          width: '100%',
          height: 500,
          chart: {
              title: 'Growth changes'
          }
      },
      growthChanges: []
    }
  },
  computed: {
    currentRoute() {
      return this.$route.name
    },
    selectedPathology() {
        let result = this.pathologies.find(t => t._id === this.pathologyId)
        let tpval = {
            id: result._id,
            type: result.type,
            name: result.name
        }
        return tpval
    }
  },
  methods: {
    changePathology() {
      this.patient.pathology = this.selectedPathology
    },
    addNumber() {
      this.numErrors = []
      if (this.emergencyNumber.phone.length < 2) {
        this.numErrors.push(this.$t("errors.phoneInvalid"))
      }
      if (this.emergencyNumber.name.length === 0) {
        this.numErrors.push(this.$t("errors.phoneNameInvalid"))
      }
      if (this.patient.emergencyNumbers.length === 5) {
        this.numErrors.push(this.$t("errors.tooManyNumbers"))
      }
      if (this.numErrors.length === 0) {
        this.patient.emergencyNumbers.push(this.emergencyNumber)
        this.emergencyNumber = {
          name: '',
          phone: ''
        }
      } else {
        this.$miniToastr.error(this.numErrors.toString().split(",").join("<hr/>"))
      }
    },
    deleteNumber(index) {
      this.patient.emergencyNumbers.splice(index,1)
    },
    newForm(intent) {
      this.therapyForm = !this.therapyForm
      if (intent === 'edit') {
        this.intent = 'edit'
        this.currentTherapy = this.patient.actualTherapy
      }
      if (intent === 'new') {
        this.intent = 'new'
      }
    },
    newSize(intent) {
      console.log('INTENT', intent)
      this.sizeForm = !this.sizeForm
      this.sizes.height = this.patient.heightCm
      this.sizes.weight = this.patient.weightKg
      if (intent === 'edit') {
        this.sizes.dateOfChangeForEdit = this.patient.growthHistory[0].dateOfChange
        this.sizeIntent = 'edit'
      }
      if (intent === 'new') {
        this.sizeIntent = 'new'
      }
    },
    cancelNewTherapy() {
      this.therapyForm = false
      this.patient.newTherapy = false
      this.patient.changeTherapy = false
      this.currentTherapy = {
        drugs: []
      }
    },
    saveTherapy() {
      this.errors = []
      if (!this.currentTherapy.drugs || this.currentTherapy.drugs.length === 0) {
        this.errors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.drugs')]))
      }
      if (!this.currentTherapy.startDate || this.currentTherapy.startDate.length === 0) {
        this.errors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.startDate')]))
      }
      if (this.errors.length === 0) {
        this.patient.actualTherapy = this.currentTherapy
        // Set intent
        if (this.intent === 'edit') {
          this.patient.newTherapy = false
          this.patient.changeTherapy = true
        }
        if (this.intent === 'new') {
          this.patient.changeTherapy = false
          this.patient.newTherapy = true
        }
        this.therapyForm = false
        this.$emit('updatepatient')
      } else {
        this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
      }
    },
    cancelSizeChange() {
      this.sizeForm = false
      this.patient.newSize = false
      this.patient.sizeChange = false
    },
    saveSizeChange() {
      // Set intent
      
      this.$emit('updatepatient')
    },
    getCertificate() {
      this.patient.certificate = this.$refs.certificate.files[0]
      this.currentCertificate = this.$refs.certificate.files[0]
    },
    getAvatar() {
      this.patient.avatar = this.$refs.avatar.files[0]
      this.currentAvatar = this.$refs.avatar.files[0]
    },
    getUrl(img) {
      return URL.createObjectURL(img)
    },
    deleteCertificate() {
      this.$refs.certificate.value = ''
      this.currentCertificate = {}
      delete this.patient.certificate
    },
    deleteAvatar() {
      this.$refs.avatar.value = ''
      this.currentAvatar = {}
      delete this.patient.avatar
    },
    setSize() {
      this.patient.heightCm = this.sizes.height
      this.patient.weightKg = this.sizes.weight
      if (this.sizeIntent == 'new'){
        this.$set(this.patient, 'dateOfChangeForNew', this.sizes.dateOfChangeForNew.getTime())
      }
    },
    setStats: async function() {
      let gh = []
      let gw = []
      let ga = []
      await _.forEach(this.patient.growthHistory, item => {
          let current = [moment(new Date(item['dateOfChange'])).format('YYYY-MM-DD'), item['height']]
          let currentWeight = [moment(new Date(item['dateOfChange'])).format('YYYY-MM-DD'), item['weight']]
          let currentGrowth = [moment(new Date(item['dateOfChange'])).format('YYYY-MM-DD'), item['height'], item['weight']]
          gh.unshift(current)
          gw.unshift(currentWeight)
          ga.unshift(currentGrowth)
      })
      gh.unshift(['Day', 'Height'])
      gw.unshift(['Day', 'Weight'])
      ga.unshift(['Day', 'Height', 'Weight'])
      this.heightChanges = gh
      this.weightChanges = gw
      this.growthChanges = ga
    }
  },
  mounted: async function() {
    let pathologies = await LovService.all('pathology', false)
    if (pathologies) {
      this.pathologies = pathologies.data
    }
    if (this.currentRoute === 'newPatient') {
      this.patient.actualTherapy = this.currentTherapy
    }
    if (this.patient.pathology && this.patient.pathology.id) {
      this.pathologyId = this.patient.pathology.id
    }
    await this.setStats()
  }
}
</script>

<style lang="scss">
  .bottom-space {
    margin-bottom: 15px;
  }
  .therapy-form-container {
    background-color: #F5F5F5;
    padding: 15px;
    box-sizing: border-box;
    border-radius: 10px;
    margin-bottom: 15px;
  }
  .dropzone {
        width: 100%;
        text-align: center;
        background-color: #eee;
        display: flex;
        position: relative;
        align-items: center;
        justify-content: center;
        min-height: 120px;
        outline: 2px dashed #eee;
        outline-offset: 5px;
        border: none;
        transition: all .5s ease;

        h5 {
          padding-top: 15px; 
          span {
            margin-top: 15px;
            display: block;
            font-size: 12px;

            strong {
              text-transform: uppercase;
            }
          }
        }

        &:hover {
            background-color: darken(#eee,10%);
            outline: 2px dashed darken(#eee,10%)
        }

        input {
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0 !important;
            width: 100%;
            height: 100%;
            cursor: pointer;
        }
    }
    .dropzone.avatar-upload {
      min-height: 258px;
    }
    .selectedAvatar {
      text-align: center;
      img {
        max-width: 100%;
        max-height: 258px;
      }
    }
</style>
